import { AuthPage } from 'components/pages';
import React from 'react';

export const Auth = () => {
  return <AuthPage/>
};

